// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d899e6b2","453":"216a9442","667":"ea4614a5"}[chunkId] + ".chunk.js";
};